import { Box, Flex, VStack } from "@chakra-ui/react"
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Hero from "./pages/Hero"
import About from "./pages/About"
import AnimatedCursor from "react-animated-cursor"
import NavBar from "./pages/Navbar"
import Expertise from "./pages/Expertise"
import Skills from "./pages/Skills"
import Experience from "./pages/Experience"
import Footer from "./pages/Footer"
import ContactTestimonials from "./pages/ContactTestimonials"
import ParallaxTextSection from "./pages/ParallaxTextSection"
import Projects from "./pages/Projects"
import News from "./pages/News"
import ProjectDetail from "./pages/ProjectDetail"
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Home page component
const HomePage = () => (
	<>
		<Hero />
		<ParallaxTextSection />
		<About />
		<Expertise />
		<Skills />
		<Experience />
		<Projects />
		<News />
		<ContactTestimonials />
		<Footer />
	</>
);

export const App = () => (
	<BrowserRouter>
		<ScrollToTop />
		<Box
			backgroundColor={"black.200"}
			justifyContent={"center"}
		>
			{/* Animated Cursor */}
			<Box
				display={{ base: "none", md: "block" }}
				zIndex={1500}
			>
				{/* Animated Cursor */}
				<Box display={{ base: "none", md: "block" }}>
					<AnimatedCursor
						innerSize={5}
						outerSize={25}
						color='16, 185, 129'
						outerAlpha={0.2}
						innerScale={0.7}
						outerScale={1.5}
						trailingSpeed={3}
						outerStyle={{
							border: '2px solid #10B981',
							zIndex: 1500,
						}}
						innerStyle={{
							zIndex: 1500,
						}}
						clickables={[
							'a',
							'input[type="text"]',
							'input[type="email"]',
							'input[type="number"]',
							'input[type="submit"]',
							'input[type="image"]',
							'label[for]',
							'select',
							'textarea',
							'button',
							'.link'
						]}
					/>
				</Box>
			</Box>
			{/* Page content wrapper */}
			<VStack
				margin={"auto"}
				backgroundColor={"black.200"}
				maxWidth="2000px"
				gap={0}
				userSelect={"none"}
			>
				{/* Navbar Opacity */}
				<Flex
					background={"rgba(3,17,18,0.4)"}
					backdropFilter={"saturate(180%) blur(10px)"}
					justifyContent={"center"}
					position={"fixed"}
					maxWidth="2000px"
					width={"100%"}
					zIndex={100}
				>
					<NavBar />
				</Flex>

				{/* Routes */}
				<Routes>
					{/* Home */}
					<Route path="/" element={<HomePage />} />
					
					{/* Project Details */}
					<Route path="/projects/:projectId" element={<ProjectDetail />} />
				</Routes>
			</VStack>
		</Box>
	</BrowserRouter>
)